import { Routes, Route } from "react-router-dom";
import { useRef } from "react";
import { Toast } from "primereact/toast";
import "./App.css";

// Import route configuration and protection components
import {
  ROUTE_CONFIG_WITH_COMPONENTS,
  RouteConfigWithComponents,
} from "./config/routeGenerator";
import {
  AdminProtectedRoute,
  ProtectedRoute,
  PlatformsProtectedRoute,
} from "./utils/AdminProtectedRoute";
import AuthNavigateRegistrar from "./Components/Auth/AuthNavigateRegistrar";
import AnalyticsPageListener from "./Components/Analytics/AnalyticsPageListener";

const App = () => {
  const toast = useRef<Toast>(null);

  const getWrapper = (route: RouteConfigWithComponents) => {
    if (!route.protected) return null;
    if (route.adminOnly) return AdminProtectedRoute;
    if (route.platformsOnly) return PlatformsProtectedRoute;
    return ProtectedRoute;
  };

  const renderChildren = (children?: RouteConfigWithComponents[]) => {
    if (!children) return null;
    return children.map((child, index) => {
      const ChildWrapper = getWrapper(child);
      const ChildElement = child.element as any;
      const grandChildren = renderChildren(child.children);

      const keyBase = child.path || child.index ? "index" : `child-${index}`;
      const childCore = child.index ? (
        <Route index element={<ChildElement />} key={keyBase} />
      ) : (
        <Route path={child.path} element={<ChildElement />} key={keyBase}>
          {grandChildren}
        </Route>
      );

      if (ChildWrapper) {
        return (
          <Route element={<ChildWrapper />} key={`wrap-${keyBase}`}>
            {childCore}
          </Route>
        );
      }

      return childCore;
    });
  };

  const renderRoutes = (routes: RouteConfigWithComponents[]) => {
    return routes.map((route) => {
      const Wrapper = getWrapper(route);
      const Element = route.element as any;
      const children = renderChildren(route.children);

      const core = (
        <Route path={route.path} element={<Element />} key={route.path}>
          {children}
        </Route>
      );

      if (Wrapper) {
        return (
          <Route element={<Wrapper />} key={`wrap-${route.path}`}>
            {core}
          </Route>
        );
      }

      return core;
    });
  };

  return (
    <div>
      <AnalyticsPageListener />
      <AuthNavigateRegistrar />
      <Toast ref={toast} />
      <Routes>{renderRoutes(ROUTE_CONFIG_WITH_COMPONENTS)}</Routes>
    </div>
  );
};

export default App;
